import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { DeviceService } from '../service/device.service';
import { Overlay } from "@angular/cdk/overlay";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { PeriodicExecution } from '../model/periodicExecution';
import { ProgrammedExecution } from '../model/programmedExecution';
import { MatTableDataSource } from '@angular/material/table';
import { DevicePilomat } from '../model/devicePilomat';
import { AddProgrammedExecutionsComponent } from '../add-programmed-executions/add-programmed-executions.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '../service/user.service';

@Component({
  selector: 'app-programmed-executions',
  templateUrl: './programmed-executions.component.html',
  styleUrls: ['./programmed-executions.component.css']
})
export class ProgrammedExecutionsComponent implements OnInit {

  devices: DevicePilomat[] = [];
  devicesWithoutV123: DevicePilomat[] = [];

  devicesWithV123: string = "";


  @Input() filter: string;
  @Input() userCanExecutionEdit: boolean;

  programmedExecutions: ProgrammedExecution[] = [];

  warningString = $localize`:@@programmed_executions_dialog_warning:Attenzione`;


  @ViewChild('programmedExecutionstable', { static: true }) table;
  @ViewChild('programmedExecutionsloader', { static: true }) loader;

  @ViewChild(MatSort) sort: MatSort;


  displayedColumnsProgrammed: string[] = [
    'serial',
    'description',
    'fromDate',
    'toDate',
    'result',
    'deleteExecution'
  ];

  constructor(
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private overlay: Overlay,
  ) { }

  ngOnInit(): void {

  }


  ngAfterViewInit() {
    this.loader.showLoading();
    setTimeout(() => { this.getDevices(); }, 500);
    // this.getDevices();
  }

  filterProgrammedTable(data: ProgrammedExecution, filter: string): boolean {
    if (data.serial && data.serial.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.description && data.description.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.result && data.result.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    return false;
  }



  addExecution() {
    if (this.devices.length == 0) {

      let message = $localize`:@@programmed_executions_dialog_no_compatible_devices:Non sono stati trovati dispositivi compatibili con gli automatismi, si prega di creare un'automazione`;
      let header = this.warningString;

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '450px',
        data: { message, header },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {
        if (response) {
        }
      });

    } else {


      if (this.devicesWithV123.length > 0) {

        let message = $localize`:@@programmed_executions_dialog_found_v123_devices:Sono stati trovati dispositivi che non sono compatibili con gli automatismi, si prega di creare automazioni per questi. I loro seriali sono: :` + " " + this.devicesWithV123;
        let header = this.warningString;

        const scrollStrategy = this.overlay.scrollStrategies.reposition();

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '450px',
          data: { message, header },
          scrollStrategy,
        });

        dialogRef.afterClosed().subscribe((response) => {

          this.openAddExecutionDialog();

        });

      } else {

        this.openAddExecutionDialog();

      }

    }
  }

  openAddExecutionDialog() {

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(AddProgrammedExecutionsComponent, {
      width: "1100px",
      data: { devices: this.devicesWithoutV123 },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == "Success") {
        let snackBarRef = this.snackBar.open($localize`:@@programmed_executions_creation_success:Automatismo creato con successo`, $localize`:@@programmed_executions_close:chiudi `, {
          duration: 3000
        });
        this.programmedExecutions = [];
        this.loader.showLoading();
        this.getProgrammedExecutions(0);
      } else if (result == "Error") {
        let snackBarRef = this.snackBar.open($localize`:@@programmed_executions_creation_error:Errore nella creazione degli automatismi`, $localize`:@@programmed_executions_close:chiudi `, {
          duration: 3000
        });
        this.loader.showError();
      }
    });


  }


  onKey(event: any) {
    this.filter = event.target.value;
    this.table.dataSource.filter = this.filter.trim().toLowerCase();
  }

  getDevices() {
    this.deviceService.getDevices().subscribe(data => {


      for (let device of data) {
        // per la get degli automatismi
        this.devices.push(device);
        //                            <123
        if (device.systemInfo.version < DevicePilomat.MIN_VER_FORCEDLOW_REASON) {
          // da passare nel dialog di creazione
          this.devicesWithoutV123.push(device);
        } else {
          // da passare nel dialog di avviso
          this.devicesWithV123 += device.serial + ", ";
        }
      }

      if (this.devicesWithV123.length > 0) {
        this.devicesWithV123 = this.devicesWithV123.slice(0, -2);
      }


      this.cdRef.detectChanges();
      this.getProgrammedExecutions(0);

    });
  }

  getProgrammedExecutions(index: number) {
    if (index < this.devices.length) {
      const obs = this.deviceService.getProgrammedExecution(this.devices[index].serial);
      obs.subscribe(data => {

        for (let i = 0; i < data.length; i++) {
          this.programmedExecutions.push(data[i]);
        }
        this.getProgrammedExecutions(index + 1);

      }, error => {
        this.loader.hideLoading();
        this.loader.showError();
      });
    } else {
      this.table.dataSource = new MatTableDataSource(this.programmedExecutions);
      this.table.dataSource.filterPredicate = this.filterProgrammedTable;
      this.table.dataSource.sort = this.sort;
      setTimeout(() => {
        this.loader.hideLoading();
      }, 250);
    }
  }

  deleteExecution(execution: ProgrammedExecution) {
    let message = $localize`:@@programmed_execution_dialog_confirm:Desideri eliminare l'automatismo?`;
    let confirmMessage = $localize`:@@programmed_execution_dialog_confirm_yes:Sì, elimina`;
    let cancelMessage = $localize`:@@programmed_execution_dialog_confirm_no:No, annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '450px',
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.deviceService.deleteProgrammedExecution(execution.serial, execution.id).subscribe((response) => {
          let snackBarRef = this.snackBar.open($localize`:@@programmed_executions_deletion_success:Automatismo eliminato con successo`, $localize`:@@programmed_executions_close:chiudi `, {
            duration: 3000
          });
          this.programmedExecutions = [];
          this.loader.showLoading();
          this.getProgrammedExecutions(0);
        }, (err) => {
          // console.log(err);
        });
      }
    });
  }


}
